{
  "a11y": {
    "home": "bPanel، الصفحة الرئيسية"
  },
  "footer": {
    "rights": "جميع الحقوق محفوظة.",
    "terms": "الشروط",
    "privacy": "الخصوصية",
    "contact": "تواصل معنا"
  },
  "fields": {
    "name": "الاسم",
    "workEmail": "بريد العمل",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "passwordHint": "10 أحرف على الأقل. استخدم مزيجًا من الحروف والأرقام والرموز.",
    "company": "اسم الشركة",
    "country": "الدولة",
    "newPassword": "كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور"
  },
  "signUp": {
    "docTitle": "إنشاء حساب",
    "title": "ابدأ تجربتك المجانية",
    "subtitle": "{{days}} أيام مجانًا بكل المزايا، بدون بطاقة.",
    "haveAccount": "لديك حساب؟",
    "signIn": "سجّل الدخول",
    "terms": "أوافق على <terms>شروط الاستخدام</terms> و<privacy>سياسة الخصوصية</privacy>.",
    "submit": "ابدأ الآن مجانًا",
    "noCard": "بدون بطاقة. التجربة {{days}} أيام، ويمكنك الإلغاء في أي وقت.",
    "side": {
      "kicker": "تجربة مجانية {{days}} أيام",
      "title": "لوحة استضافة أفضل، وأسعار أوضح.",
      "points": {
        "trial": "{{days}} أيام مجانًا بكل المزايا، بدون بطاقة.",
        "install": "ثبّت bPanel على Debian أو Ubuntu بأمر واحد.",
        "ai": "نقاط ذكاء اصطناعي شهرية مع كل سيرفر."
      },
      "preview": {
        "name": "سيرفرك الأول",
        "accounts": "حسابات الاستضافة",
        "from": "تبدأ الباقات من",
        "perServer": "لكل سيرفر شهريًا"
      }
    }
  },
  "checkEmail": {
    "title": "تحقق من بريدك",
    "sentTo": "أرسلنا رابط التفعيل إلى",
    "body": "افتح الرابط لتفعيل حسابك وبدء التجربة.",
    "bodyNoEmail": "أرسلنا لك رابط التفعيل. افتح الرابط لتفعيل حسابك وبدء التجربة.",
    "resend": "أعد إرسال الرابط",
    "resent": "أرسلنا رابطًا جديدًا.",
    "spam": "لم يصلك؟ تحقق من مجلد الرسائل غير المرغوب فيها.",
    "wrongEmail": "البريد غير صحيح؟ أنشئ الحساب من جديد"
  },
  "verify": {
    "title": "تفعيل البريد",
    "working": "جارٍ تفعيل بريدك",
    "successTitle": "تم تفعيل بريدك",
    "successBody": "نجهّز لوحتك الآن.",
    "invalidTitle": "تعذّر تفعيل البريد",
    "invalidBody": "الرابط غير صالح أو انتهت صلاحيته.",
    "requestNew": "اطلب رابطًا جديدًا",
    "toSignIn": "سجّل الدخول"
  },
  "signIn": {
    "title": "سجّل الدخول",
    "subtitle": "أهلًا بعودتك إلى bPanel.",
    "forgot": "نسيت كلمة المرور؟",
    "submit": "تسجيل الدخول",
    "noAccount": "ليس لديك حساب؟",
    "getStarted": "ابدأ الآن مجانًا",
    "verifyNow": "افتح رابط التفعيل",
    "mockHint": "كلمة المرور لكل الحسابات التجريبية: {{password}}"
  },
  "totp": {
    "title": "المصادقة الثنائية",
    "body": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.",
    "codeLabel": "رمز المصادقة",
    "submit": "تحقق",
    "back": "العودة إلى تسجيل الدخول",
    "mockHint": "الرمز في الوضع التجريبي: {{code}}"
  },
  "forgot": {
    "title": "نسيت كلمة المرور؟",
    "body": "أدخل بريدك ونرسل لك رابطًا لتعيين كلمة مرور جديدة.",
    "submit": "أرسل الرابط",
    "sentTitle": "تحقق من بريدك",
    "sentBody": "إذا كان البريد مسجلًا لدينا، سيصلك رابط خلال دقائق.",
    "back": "العودة إلى تسجيل الدخول"
  },
  "reset": {
    "title": "كلمة مرور جديدة",
    "body": "اختر كلمة مرور قوية لم تستخدمها من قبل.",
    "submit": "حفظ كلمة المرور",
    "doneTitle": "تم تغيير كلمة المرور",
    "doneBody": "سجّل الدخول بكلمة المرور الجديدة.",
    "toSignIn": "سجّل الدخول",
    "requestNew": "اطلب رابطًا جديدًا"
  },
  "expired": {
    "title": "انتهت جلستك",
    "body": "سجّل الدخول مرة أخرى وتابع من الصفحة نفسها.",
    "submit": "متابعة",
    "signOut": "تسجيل الخروج"
  },
  "mockInbox": {
    "title": "صندوق البريد التجريبي",
    "note": "في الوضع التجريبي لا نرسل بريدًا حقيقيًا. افتح الرسالة من هنا.",
    "empty": "لم تصل رسائل بعد.",
    "openVerify": "افتح رابط التفعيل",
    "openReset": "افتح رابط تعيين كلمة المرور",
    "latest": "الأحدث"
  },
  "demo": {
    "title": "حسابات تجريبية",
    "note": "ادخل بأحد هذه الحسابات لترى اللوحة في حالات مختلفة.",
    "personas": {
      "rimal": "أربعة سيرفرات وسجل فواتير",
      "najm": "في منتصف التجربة، تبقّت 5 أيام",
      "new": "حساب جديد بدون سيرفرات"
    }
  }
}
